// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cd6ad052","514":"1b894d75","977":"c3d6839e"}[chunkId] + ".chunk.js";
};